import { blue, green } from "@mui/material/colors";
import StatusChip from "@entrilia/shared/components/StatusChip";
import { makeModeAwareAccent } from "@entrilia/shared/utilities/colorHelper";
import type { PortalRoleWithNoneValue } from "../../api/types/accessTypes";
import type { InvestorPortalRole } from "../../api/types/workflowTypes";
import { portalRoleCaptionMap } from "../../utilities/enumCaptions";

type Role = PortalRoleWithNoneValue | InvestorPortalRole;

interface Props {
  role?: Role;
}

const PortalRoleChip = ({ role }: Props) => {
  switch (role) {
    case "LP_Admin":
    case "Admin": {
      return <StatusChip label={portalRoleCaptionMap["LP_Admin"]} color={(t) => makeModeAwareAccent(t, blue)} />;
    }
    case "LP_Member":
    case "Portfolio_Monitoring_Portal_Member":
    case "Member": {
      return <StatusChip label={portalRoleCaptionMap["LP_Member"]} color={(t) => makeModeAwareAccent(t, green)} />;
    }
    case "None":
    case undefined:
    default: {
      return <StatusChip label="None" color={(t) => t.palette.text.secondary} neutral />;
    }
  }
};

export default PortalRoleChip;
